// Component for alerting user that only 4 columns are allowed at a time
import React from 'react';
// Material UI
import { makeStyles } from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

function Alert(props) {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles(theme => ({
	root: {
		width: '100%',
		'& > * + *': {
			marginTop: theme.spacing(2)
		}
	}
}));

const ColumnAlert = ({ open, handleClose }) => {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<Snackbar open={open} autoHideDuration={5000} onClose={handleClose}>
				<Alert onClose={handleClose} severity="warning">
					Only 4 columns are supported per panel, please remove a column before
					adding another.
				</Alert>
			</Snackbar>
		</div>
	);
};

export default ColumnAlert;
